import * as React from 'react';

import { HeadlineLevel, LOCALE, } from 'features/ui/enums';
import { SearchResult } from 'features/search/types';
import { capitalizeFirstLetter } from 'features/services/utils/helpers';
import { DisposalForm, StageStatus } from 'features/search/filters/enums';
import { cleanFinnishNames, getDisposalFormName } from 'features/services/utils/name-helpers';
import { getCurrentLocale, getLocalizedPrice, getLocalizedRok } from 'features/services/utils/env-helper';

import { ContentTemplate } from './_contentTemplate';

interface Props {
    residence: SearchResult;
    level?: HeadlineLevel;
}

export const ProjectContent: React.FunctionComponent<Props> = ({ residence, level }) => {
    const locale = getCurrentLocale();
    let firstPrice = '';
    let secondPrice = '';
    let description = '';
    
    const shouldRender = (min, max) => {
        if(residence.stageStatus === StageStatus.SUCCESSION) return false;
        if(typeof min === 'undefined' || min === null) return false;
        if(typeof max === 'undefined' || max === null) return false;
        if(min === 0) return false;
        if(max === 0) return false;

        return true;
    };

    const getFirstPriceString = () => {
        if(shouldRender(residence.minPrice, residence.maxPrice)) {
            firstPrice += getLocalizedPrice(residence.minPrice);

            if(residence.minPrice !== residence.maxPrice) {
                firstPrice += ' - ' + getLocalizedPrice(residence.maxPrice);
            }
        }
        return firstPrice;
    };
    const getSecondPriceString = () => {
        if(locale === LOCALE.FI && shouldRender(residence.jmoyTotalPriceMin, residence.jmoyTotalPriceMax)) {
            secondPrice += getLocalizedPrice(residence.jmoyTotalPriceMin);

            if(residence.jmoyTotalPriceMin !== residence.jmoyTotalPriceMax) {
                secondPrice += ' - ' + getLocalizedPrice(residence.jmoyTotalPriceMax);
            }
        } 
        
        return secondPrice;
    };
    const getDescription = () => {
        if(residence.disposalForm && locale !== LOCALE.FI) {
            description += getDisposalFormName(residence.disposalForm as DisposalForm);

            if(shouldRender(residence.minRooms, residence.maxRooms)) description += ' • ';
        }

        if(shouldRender(residence.minRooms, residence.maxRooms)) {
            description += residence.minRooms === residence.maxRooms 
                ? getLocalizedRok(residence.minRooms)
                : residence.minRooms + ' - ' + getLocalizedRok(residence.maxRooms);
        }

        return description;
    }
    
    return (
        <ContentTemplate 
            residence={residence} 
            headline={capitalizeFirstLetter(cleanFinnishNames(residence.name))} 
            firstPrice={getFirstPriceString()} 
            secondPrice={getSecondPriceString()}
            description={getDescription()}
            level={level}
        />
    )
}